
const caloriePerServingRates = {
  input_footprint_shopping_food_meatfisheggs: 210,
  input_footprint_shopping_food_meat_beefpork: 213,
  input_footprint_shopping_food_meat_poultry: 204,
  input_footprint_shopping_food_meat_fish: 204,
  input_footprint_shopping_food_meat_other: 204,
  input_footprint_shopping_food_dairy: 120,
  input_footprint_shopping_food_fruitvegetables: 70,
  input_footprint_shopping_food_cereals: 150,
  input_footprint_shopping_food_otherfood: 200,
};

// eslint-disable-next-line import/prefer-default-export
export const convertCaloriesToServings = (apiKey, calories) =>
  calories / caloriePerServingRates[apiKey];
